import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/images/compass_icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-37ea067e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "p-d-flex p-flex-wrap p-ai-center p-ml-6 main-block-search",
  ref: "target"
}
const _hoisted_2 = { class: "p-d-flex popular" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "p-mr-3"
}, null, -1))
const _hoisted_4 = {
  key: 1,
  class: "color-text p-text-bold p-text-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-text p-ml-6 p-mr-6" }, "|", -1))
const _hoisted_6 = { class: "p-input-icon-left" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "p-d-flex popular",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.showBrowsePopular = !$setup.showBrowsePopular), ["prevent"]))
      }, [
        _hoisted_3,
        (!$setup.browsePopular)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "color-text p-text-bold",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'content-items' })))
            }, " Browse Content ∨ "))
          : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($setup.browsePopular) + " ∨", 1))
      ])
    ]),
    _hoisted_5,
    _createElementVNode("span", _hoisted_6, [
      _hoisted_7,
      _createVNode(_component_InputText, {
        type: "text",
        modelValue: $setup.searchAnythingValueInput,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.searchAnythingValueInput) = $event)),
        placeholder: "Search for anything",
        class: "anything"
      }, null, 8, ["modelValue"])
    ])
  ], 512))
}